<template>
  <div>
    <div class="page-box">
      <el-table
        :data="tableData"
        v-loading="loading">
        <el-table-column
          prop="createTime"
          label="下单时间"
          width="180">
        </el-table-column>
        <el-table-column
          prop="orderNo"
          label="订单号"
          width="180">
          <div class="link"
               slot-scope="{row}"
               @click="$router.push({path: `/member/orderDetail/${row.orderNo}`})">
            {{ row.orderNo }}
          </div>
        </el-table-column>
        <el-table-column
          prop="orderAmount"
          label="订单金额"
          width="110">
        </el-table-column>
        <el-table-column
          prop="serviceName"
          label="预约服务"
          width="200">
        </el-table-column>
        <el-table-column
          prop="orderTime"
          label="预约时间"
          width="180">
        </el-table-column>
        <el-table-column
          prop="addr"
          label="地址">
        </el-table-column>
        <el-table-column
          prop="visitTime"
          label="回访时间"
          width="180">
        </el-table-column>
        <el-table-column
          prop="visitName"
          label="回访人"
          width="80">
        </el-table-column>
        <el-table-column
          prop="visitContent"
          label="回访结果"
          width="400">
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page.pageNum"
        :page-sizes="[10, 15, 20]"
        :page-size="page.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="page.total">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import {order} from '../../api'

export default {
  name: 'LogServe',
  props: {
    memberId: String
  },
  mounted () {
    this.getTableData()
  },
  data () {
    return {
      loading: false,
      page: {
        pageSize: 10,
        pageNum: 1
      },
      tableData: []
    }
  },
  methods: {
    async getTableData () {
      this.loading = true
      let {data, page} = await order.getOrderListPage({
        page: this.page,
        param: {
          orgCode: this.$store.state.user.orgCode,
          memberId: this.memberId,
          visitFlag: true
        }
      })
      this.page = page
      this.loading = false
      this.tableData = data
    },
    handleSizeChange (arg) {
      this.page.pageSize = arg
      this.getData()
    },
    handleCurrentChange (arg) {
      this.page.pageNum = arg
      this.getData()
    },
    async goBack () {
      this.$closeCurrentView()
      this.$router.back()
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
